import type { CaptureContext } from '@sentry/nextjs';

export const captureMessage = async (message: string, captureContext?: CaptureContext) => {
  /*   if (Sentry.getClient()) {
    Sentry.captureMessage(message, captureContext);
  } else if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
    const { sendBuildMessage } = await import('./slackClient');

    await sendBuildMessage(message, captureContext);
  } */

  console.warn(message, captureContext);
};
